import axios from './api';

/**
 * 定价配置服务
 * 用于获取公共定价配置数据
 */
export const pricingConfigService = {
  /**
   * 获取月订阅配置
   */
  getMonthlyPlans: async (language) => {
    const allConfigs = await pricingConfigService.getAllPricingConfigs(language);
    return allConfigs.monthly;
  },

  /**
   * 获取年订阅配置
   */
  getYearlyPlans: async (language) => {
    const allConfigs = await pricingConfigService.getAllPricingConfigs(language);
    return allConfigs.yearly;
  },

  /**
   * 获取积分包配置
   */
  getCreditPackages: async (language) => {
    const allConfigs = await pricingConfigService.getAllPricingConfigs(language);
    return allConfigs.credits;
  },

  /**
   * 获取所有定价配置（包含月订阅、年订阅、积分包）
   * 后端返回List<CreditPackageDto>，前端需要按类型分组
   */
  getAllPricingConfigs: async (language) => {
    const params = {};
    if (language) {
      // Map frontend language codes to backend API language codes
      // en -> en
      // zh-TW -> tc
      params.language = language === 'zh-TW' ? 'tc' : language;
    }
    const response = await axios.get('/public/pricing/all', { params });
    const packages = response.data || [];

    // 按套餐类型分组处理
    const monthly = [];
    const yearly = [];
    const credits = [];

    packages.forEach(pkg => {
      // 根据packageType字段判断套餐类型
      // 优先检查pkg.packageType，然后检查configData中的packageType，最后通过configKey判断
      const packageType = pkg.packageType || 
                          (pkg.configData && typeof pkg.configData === 'object' ? pkg.configData.packageType : null) ||
                          (pkg.configKey && pkg.configKey.includes('monthly') ? 'monthly' : 
                           (pkg.configKey && pkg.configKey.includes('yearly') ? 'yearly' : 'credits'));

      if (packageType === 'monthly') {
        monthly.push(pkg);
      } else if (packageType === 'yearly') {
        yearly.push(pkg);
      } else {
        // 默认归类为积分包
        credits.push(pkg);
      }
    });

    return {
      monthly,
      yearly,
      credits
    };
  }
};

export default pricingConfigService;